import * as Components from '../components'
import * as Form from '../form'
import * as Hooks from '../hooks'
import * as Navigation from '../navigation'
import * as Stores from '../stores'
import { Spinner, View } from 'tamagui'
import { useForm, useWatch } from 'react-hook-form'
import { router } from 'expo-router'
import { mesaColorNames } from '@/src/common/theme'

type OfferCodeFormValues = Parameters<ReturnType<typeof Hooks.useOfferCodeValidator>>[0]

const DefaultValues = {
  offerCode: '',
} satisfies OfferCodeFormValues

const containsValues = (values: OfferCodeFormValues) => values.offerCode

export function OfferCodeScreen() {
  const updateField = Stores.useCardApplicationFormStore((s) => s.updateField)
  const cardApplicationForm = Stores.useCardApplicationFormStore((s) => s.cardApplicationForm)
  const offerCodeValidator = Hooks.useOfferCodeValidator()
  const defaultValues = containsValues(cardApplicationForm) ? cardApplicationForm : DefaultValues

  const form = useForm<OfferCodeFormValues>({
    defaultValues,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    resolver: offerCodeValidator,
  })

  const offerCode = useWatch({ control: form.control, name: 'offerCode' })
  const offerCodeState = form.getFieldState('offerCode', form.formState)
  const showOfferSuccess =
    !!offerCode && offerCodeState.isTouched && !offerCodeState.error && !form.formState.isValidating

  const onSubmit = form.handleSubmit((data) => {
    updateField('offerCode', data.offerCode)
    router.push(Navigation.Routes.FindYourHome.route)
  })

  return (
    <View flex={1} bg="$white1" pb="$8">
      <Components.ApplicationScreen>
        <Components.ApplicationScreen.Header previousRoute={Navigation.Routes.CardOnboarding} />
        <Components.ApplicationScreen.Content title="Have an offer code?">
          <Components.FormHelpText>
            If so please enter it now, if not no worries. You can submit your application without
            one.
          </Components.FormHelpText>
          <Components.FormInput
            control={form.control}
            name="offerCode"
            {...Form.FormInputProps.offerCode}
            info={{
              success: showOfferSuccess ? 'Offer code accepted' : undefined,
            }}
            leftIcon={
              form.formState.isValidating ? (
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- nondeterministic type complexity
                // @ts-ignore union too complex from Tamagui
                <Spinner
                  size="small"
                  scale={0.8}
                  color={mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9']}
                  pr="$1.5"
                />
              ) : undefined
            }
          />
        </Components.ApplicationScreen.Content>
        <Components.ApplicationScreen.SubmitButton
          onPress={() => void onSubmit()}
          disabled={!form.formState.isValid}
          loading={form.formState.isSubmitting}
          title="Continue"
        />
      </Components.ApplicationScreen>
    </View>
  )
}
